import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, Fragment, useRef, useState, useEffect } from "react";
import { useBannerOrBlocker, joinWithAndSeparator } from "../../../hooks";
import { CookieProperty } from "./cookieProperty";
import { LinkToggle } from "../linkToggle";
const CookiePropertyListLessRelevant = (param)=>{
    let { expandable, children, labelModifications = {} } = param;
    const { group: { detailsHideLessRelevant }, i18n: { andSeparator, showLessRelevantDetails, hideLessRelevantDetails } } = useBannerOrBlocker();
    const ref = useRef(null);
    const [joinedAnd, setJoinedAnd] = useState("");
    useEffect(()=>{
        const { current } = ref;
        if (current) {
            const labels = [
                ...new Set([
                    ...current.querySelectorAll(":scope>div>strong")
                ].map((c)=>{
                    const originalLabel = c.innerText.replace(/:?\s+$/, "");
                    return labelModifications[originalLabel] || originalLabel;
                }))
            ];
            setJoinedAnd(joinWithAndSeparator(labels, andSeparator));
        }
    }, [
        ref.current,
        labelModifications
    ]);
    const replaceVariables = useCallback((str)=>str.replace("%s", joinedAnd), [
        joinedAnd
    ]);
    return detailsHideLessRelevant && expandable ? /*#__PURE__*/ _jsx("div", {
        "aria-hidden": !joinedAnd,
        hidden: !joinedAnd,
        children: /*#__PURE__*/ _jsx(CookieProperty, {
            value: /*#__PURE__*/ _jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("br", {}),
                    /*#__PURE__*/ _jsx(LinkToggle, {
                        showMore: replaceVariables(showLessRelevantDetails),
                        hideMore: replaceVariables(hideLessRelevantDetails),
                        style: {
                            fontStyle: "italic"
                        },
                        forceRender: true,
                        children: /*#__PURE__*/ _jsxs("div", {
                            ref: ref,
                            children: [
                                /*#__PURE__*/ _jsx("br", {}),
                                children
                            ]
                        })
                    })
                ]
            })
        })
    }) : children;
};
export { CookiePropertyListLessRelevant };
